export default __webpack_public_path__ + "static/media/esgot-screenshot-06.cf79c9d1.png";